if (!customElements.get('free-shipping-bar')) {
  customElements.define('free-shipping-bar', class FreeShippingBar extends HTMLElement {
    constructor() {
      super();
      this.emptyMessage = this.querySelector('.free-shipping-bar__empty-message');
      this.unreachedMessage = this.querySelector('.free-shipping-bar__unreached-message');
      this.reachedMessage = this.querySelector('.free-shipping-bar__reached-message');
      if (this.emptyMessage) {
        this.emptyMessageText = this.emptyMessage.innerHTML;
      }
      if(this.unreachedMessage) {
        this.unreachedMessageText = this.unreachedMessage.innerHTML;
      }
      this.percentNumber = this.querySelector('.free-shipping-bar__progress-number');
      this.showPercent = this.dataset.showPercent !== 'false';
      if(!this.dataset.threshold) return;
      this.threshold = parseInt(this.dataset.threshold);
      this.updatePercentVisibility();
      this.calculateBar(parseInt(this.dataset.total), parseInt(this.dataset.itemCount || '0', 10));
      this.onCartChangeHandler = this.onCartChange.bind(this);
      document.addEventListener('afterCartChanged', this.onCartChangeHandler);
      document.addEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    disconnectedCallback() {
      document.removeEventListener('afterCartChanged', this.onCartChangeHandler);
      document.removeEventListener('afterUpdateQuantity', this.onCartChangeHandler);
    }

    updatePercentVisibility() {
      if (!this.percentNumber) return;
      this.classList.toggle('free-shipping-bar--hide-percent', !this.showPercent);
      this.percentNumber.style.display = this.showPercent ? '' : 'none';
    }

    calculateBar(currentTotal, itemCount) {
      const total = currentTotal / parseFloat(Shopify.currency.rate);
      const isEmpty = itemCount === 0;

      if (isEmpty) {
        this.classList.remove('completed');
        this.style.setProperty('--percent', '0%');
        this.hideUnreachedMessage();
        this.hideReachedMessage();
        this.showEmptyMessage();
        if (this.percentNumber && this.showPercent) {
          this.percentNumber.textContent = '0%';
        }
        this.updatePercentVisibility();
        return;
      }

      this.hideEmptyMessage();

      if(total >= this.threshold) {
        this.style.setProperty('--percent', '100%');
        this.classList.add('completed');
        this.hideUnreachedMessage();
        this.showReachedMessage();
        if (this.percentNumber && this.showPercent) {
          this.percentNumber.textContent = `100%`;
        }
        this.updatePercentVisibility();
      }  else {
        const remain = this.threshold - total;
        const percent = (total * 100) / this.threshold;
        this.classList.remove('completed');
        this.style.setProperty('--percent', `${percent}%`);
        this.hideReachedMessage();
        this.showUnreachedMessage(remain);
        if (this.percentNumber && this.showPercent) {
          this.percentNumber.textContent = `${Math.floor(percent)}%`;
        }
        this.updatePercentVisibility();
      }
    }

    onCartChange() {
      fetch(`${routes.cart_url}`, {...fetchConfig('json', 'GET')})
      .then((response) => response.json())
      .then((response) => {
        let totalPrice = response.total_price;
        if (freeShippingBarExcludeProducts.length > 0 && response.items.length > 0) {
          response.items.forEach((item) => {
            if(freeShippingBarExcludeProducts.includes(item.product_id)) {
              totalPrice -= item.final_line_price;
            }
          });
        }
        this.calculateBar(totalPrice, response.item_count);
      });
    }

    showEmptyMessage() {
      if (!this.emptyMessage || !this.emptyMessageText) return;
      const thresholdPrice = Shopify.showPrice(this.threshold);
      this.emptyMessage.classList.remove('hidden');
      this.emptyMessage.innerHTML = this.emptyMessageText
        .replace('[threshold]', thresholdPrice)
        .replace('[remain]', thresholdPrice);
    }

    hideEmptyMessage() {
      if (!this.emptyMessage) return;
      this.emptyMessage.classList.add('hidden');
    }

    showUnreachedMessage(remainAmount) {
      if(!this.unreachedMessageText && this.unreachedMessage) return;
      const remainPrice = Shopify.showPrice(remainAmount);
      this.unreachedMessage.classList.remove('hidden');
      this.unreachedMessage.innerHTML = this.unreachedMessageText.replace('[remain]', `${remainPrice}`);
    }

    hideUnreachedMessage() {
      if(!this.unreachedMessage) return;
      this.unreachedMessage.classList.add('hidden');
    }

    showReachedMessage(remainAmount) {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.remove('hidden')
    }

    hideReachedMessage() {
      if(!this.reachedMessage) return;
      this.reachedMessage.classList.add('hidden');
    }
  });
}